/// <reference path="../include.ts" />

namespace project_common {

	export class DataParser {

		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static localize<T>(localizable:Localizable<T>, lang:Lang, useFallback:boolean = true):T {
			let value:T;
			if ((value = localizable[lang]) !== undefined) return value;
			if (useFallback && (value = localizable[Lang.en]) !== undefined) return value;
			return null;
		}





		public static applyTree(spot:Spot, isNeedForceUpdate:boolean):void {
			if (spot.regionsByUrn && !isNeedForceUpdate) return;
			trace('[DataParser] applyTree');

			spot.regionsByUrn = {};

			const regions = spot.regions;
			const regionCount = regions.length;
			for (let regionIndex = 0; regionIndex < regionCount; ++regionIndex) {
				const region = regions[regionIndex];
				region.areasByUrn = {};
				spot.regionsByUrn[region.urn] = region;

				const areas = region.areas;
				const areaCount = areas.length;
				for (let areaIndex = 0; areaIndex < areaCount; ++areaIndex) {
					const area = areas[areaIndex];
					area.zonesByUrn = {};
					region.areasByUrn[area.urn] = area;

					const zones = area.zones;
					const zoneCount = zones.length;
					for (let zoneIndex = 0; zoneIndex < zoneCount; ++zoneIndex) {
						const zone = zones[zoneIndex];
						area.zonesByUrn[zone.urn] = zone;
					}
				}
			}
		}





		public static getRegionFromSpot(spot:Spot, regionUrn:string):Region {
			return spot ? DataParser.getNodeFromUrl(spot.regions, regionUrn) : null;
		}

		public static getAreaFromRegion(region:Region, areaUrn:string):Area {
			return region ? DataParser.getNodeFromUrl(region.areas, areaUrn) : null;
		}

		public static getZoneFromArea(area:Area, zoneUrn:string):Zone {
			return area ? DataParser.getNodeFromUrl(area.zones, zoneUrn) : null;
		}

		public static getSpeciesFromZone(zone:Zone, speciesUrn:string):Species {
			return zone ? DataParser.getNodeFromUrl(zone.species, speciesUrn) : null;
		}

		private static getNodeFromUrl<T extends IUrnDescribable>(nodes:T[], urn:string):T {
			const nodeCount = nodes.length;
			for (let i = 0; i < nodeCount; ++i) {
				if (nodes[i].urn === urn) {
					return nodes[i];
				}
			}
			return null;
		}





		public static getFullUrnToSpecies(spot:Spot, region:Region, area:Area, zone:Zone, species:Species):string {
			return [spot.urn, region.urn, area.urn, zone.urn, species.urn].join('/');
		}

		public static getFullUrnToZone(spot:Spot, region:Region, area:Area, zone:Zone):string {
			return [spot.urn, region.urn, area.urn, zone.urn].join('/');
		}

		public static getFullUrnToArea(spot:Spot, region:Region, area:Area):string {
			return [spot.urn, region.urn, area.urn].join('/');
		}

		public static getFullUrnToRegion(spot:Spot, region:Region):string {
			return [spot.urn, region.urn].join('/');
		}

		public static splitUrns(connectedUrn:string):string[] {
			return connectedUrn.split('/');
		}





		public static nl2br(src:string):string {
			return src.replace(/\n/g, '<br>');
		}

		public static addCharClass(src:string):string {
			src = src.replace(/。/g, '<span class="char-period">。</span>');
			src = src.replace(/、/g, '<span class="char-comma">、</span>');
			return src;
		}





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
